import { FC, useEffect } from "react";
import { Trans, useTranslation } from 'react-i18next';
import CoWorkingNavBar from "./CoWorkingLandingNavBar";
import CoWorkingEventList from "./CoWorkingEventList";
import CoWorkingImageSlider from "./CoWorkingCarousel";
import CoWorkingMemberList from "./CoWorkingMemberList";
import CoWorkingNewsList from "./CoWorkingNewsList";
import CoWorkingAbout from "./CoWorkingAbout";
import CoWorkingFAQ from "./CoWorkingFAQ";
// import WorkLoungeCalendar from "./CoWorkingReservationStatus";

const CoWorkingLandingPage: FC = () => {
    const { t, i18n } = useTranslation();
    const contactUrl = process.env.REACT_APP_CONTACT_URL;

    useEffect(() => {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, []);

    return (
        <>
            <main className="w-full text-[#2C2E35]">
                <CoWorkingNavBar />

                {/* Top Section */}
                <div className="min-h-[50vh] md:min-h-[60vh] flex flex-col justify-center mt-10 md:mt-20 relative" id="top">

                    <CoWorkingImageSlider />
                </div>

                {/* About Section */}
                <div className="md:pb-12 " id="concept">
                    <CoWorkingAbout />
                </div>

                {/* Reservation Status Section */}
                {/*  <div id="reservationStatus">
                    <WorkLoungeCalendar />
                </div> */}

                {/* News Section */}
                <div className="w-full max-w-7xl mx-auto relative z-10" id="news">
                    <CoWorkingNewsList showButton={true} addMargin={false} />
                </div>

                {/* Event Section */}
                <CoWorkingEventList showButton={true} addMargin={false} />

                {/* Member Section */}
                <div className="w-full px-4  md:md:max-w-5xl lg:max-w-6xl mx-auto relative z-10" id="member">
                    <CoWorkingMemberList addMargin={false} />
                </div>

                {/* Access Section */}
                <div className="w-full px-4 pt-6 pb-4 bg-[#211916] text-white flex flex-col items-center" id="access">
                    <div className="relative mb-6">
                        <h1 className="text-5xl font-bold leading-[1.1] text-center">
                            {t('cw_lp_home_access_1')}
                        </h1>
                    </div>

                    <div className="w-full md:max-w-5xl lg:max-w-6xl text-center">
                        <div className="mb-5 md:mb-8">
                            <p className="text-lg font-medium">
                                {t('cw_lp_home_access_2')}
                            </p>
                            <p className="text-sm">
                                {t('cw_lp_home_access_3')}
                            </p>
                            <p className="text-sm mb-4">
                                {t('cw_lp_home_access_3.1')}
                            </p>

                            <p className="text-lg font-medium">
                                {t('cw_lp_home_access_4')}
                            </p>
                            <p className="text-sm">
                                {t('cw_lp_home_access_5')}
                            </p>
                            <p className="text-sm mb-4">
                                {t('cw_lp_home_access_6')}
                            </p>
                        </div>

                        <div className="relative w-full h-80 sm:h-96 lg:h-[500px] mb-8">
                            <img
                                alt="facility"
                                src="/assets/images/landing/accessLocation.png"
                                className="absolute inset-0 w-full h-full object-contain"
                            />
                        </div>
                    </div>
                </div>

                {/* collaborative facilities Section */}
                <div className="w-full px-4 py-6 md:py-8 max-w-7xl mx-auto flex flex-col items-center" >
                    <div className="relative mb-6">
                        <h1 className="text-5xl font-bold leading-[1.1] text-center">
                            {t('cw_lp_collaboration_1')}
                        </h1>
                    </div>
                    <div className="w-full md:max-w-5xl lg:max-w-6xl text-start">
                        <p className="text-lg font-bold">
                            {t('cw_lp_collaboration_2')}
                        </p>
                        <p className="text-sm font-medium mb-2 mt-2">
                            {t('cw_lp_collaboration_3')}
                        </p>
                        <p className="text-sm font-medium">
                            {t('cw_lp_collaboration_4')}
                            <a
                                href={t('cw_lp_collaboration_5')}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-500"
                            >
                                {t('cw_lp_collaboration_6')}
                            </a>
                            {t('cw_lp_collaboration_7')}
                        </p>
                    </div>

                    <div className="w-full md:max-w-5xl lg:max-w-6xl px-4 py-2 text-center">

                        <div className="relative w-full h-60 sm:h-80 mt-0 md:mt-4">
                            <img
                                alt="facility"
                                src="/assets/images/landing/jointFacilities.jpg"
                                className="absolute inset-0 w-full h-full object-contain"
                            />
                        </div>
                    </div>
                </div>

                {/* FAQ Section */}
                <div className="w-full px-4 pb-2 max-w-7xl mx-auto flex flex-col items-center" id="faq">
                    <CoWorkingFAQ />
                </div>
                {/* Contact Section */}
                <div className="w-full px-4 pb-2 max-w-7xl mx-auto flex flex-col items-center" id="access">
                    <div className="relative mb-6">
                        <h1 className="text-5xl font-bold leading-[1.1] text-center">
                            {t('cw_lp_contact_1')}
                        </h1>
                    </div>

                    <div className="w-full md:max-w-5xl lg:max-w-6xl px-4 py-2 text-center">
                        <div className="mb-8">
                            <p className="text-lg font-medium">
                                {t('cw_lp_contact_2')}
                            </p>
                            <p className="text-sm mb-4">
                                {t('cw_lp_contact_3')}
                            </p>
                            <p className="text-lg font-medium">
                                {t('cw_lp_contact_4')}
                            </p>
                            <p className="text-sm mb-4">
                                {t('cw_lp_contact_5')}
                            </p>
                            <p className="text-sm">
                                {t('cw_lp_contact_6')}
                            </p>
                            <p className="text-sm">
                                {t('cw_lp_contact_7')}
                            </p>
                            <p className="text-sm">
                                <Trans i18nKey="cw_lp_contact_8" components={[
                                    <a href={t('cw_lp_instagram_url')} target="_blank" rel="noopener noreferrer" className="underline" />
                                ]} />
                            </p>
                            <p className="text-lg font-medium mt-4">
                                {t('cw_lp_contact_9')}
                            </p>
                            <p className="text-sm">
                                {t('cw_lp_contact_10')}
                            </p>
                            <p className="text-lg mt-10">
                                {i18n.language === 'en' ? (
                                    <>
                                        <a href={contactUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                                            {t('cw_lp_contact_11')}
                                        </a>
                                        {` ${t('cw_lp_contact_12')}`}
                                    </>
                                ) : (
                                    <>
                                        {t('cw_lp_contact_12')}
                                        <a href={contactUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                                            {t('cw_lp_contact_11')}
                                        </a>
                                    </>
                                )}
                            </p>
                            <div className="flex justify-center items-center space-x-4 mt-2">
                                <a href={t('cw_lp_facebook_url')} target="_blank" rel="noopener noreferrer">
                                    <img src="/assets/logo/facebook.png" alt="Facebook" className="w-8 h-8" />
                                </a>
                                <a href={t('cw_lp_x_url')} target="_blank" rel="noopener noreferrer">
                                    <img src="/assets/logo/x.png" alt="x" className="w-6 h-6" />
                                </a>
                                <a href={t('cw_lp_peatix_url')} target="_blank" rel="noopener noreferrer">
                                    <img src="/assets/logo/peatix.png" alt="Peatix" className="w-6 h-6" />
                                </a>
                            </div>


                        </div>

                    </div>
                </div>

                {/* Footer Section */}
                <div className="w-full bg-[#222] text-white py-12" id="contact">
                    <div className="md:md:max-w-5xl lg:max-w-6xl mx-auto flex flex-col items-center text-center space-y-16">
                        <h1 className="text-5xl font-bold">{t('cw_lp_common.app_name')}</h1>
                    </div>
                </div>
            </main>
        </>
    );
};

export default CoWorkingLandingPage;
